import { render, staticRenderFns } from "./YearWater.vue?vue&type=template&id=6c3427ca&scoped=true&"
import script from "./YearWater.vue?vue&type=script&lang=js&"
export * from "./YearWater.vue?vue&type=script&lang=js&"
import style0 from "./YearWater.vue?vue&type=style&index=0&id=6c3427ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3427ca",
  null
  
)

export default component.exports